module.exports = __webpack_public_path__ + "static/media/hide-button-off.cca2f6fa.png";